
export function gssLog(...args: any[]) {
  if (typeof window !== 'undefined' && window.gss?.debug) {
    const timeNow = (new Date()).toLocaleTimeString();
    console.log(timeNow, ...args);
  }
}

export function gssErrorLog(...args: any[]) {
  if (typeof window !== 'undefined' && window.gss?.debug) {
    const timeNow = (new Date()).toLocaleTimeString();
    console.error(timeNow, ...args);
  }
}
